import { render, staticRenderFns } from "./partners-slide.vue?vue&type=template&id=03817023&scoped=true&"
import script from "./partners-slide.vue?vue&type=script&lang=js&"
export * from "./partners-slide.vue?vue&type=script&lang=js&"
import style0 from "./partners-slide.vue?vue&type=style&index=0&id=03817023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03817023",
  null
  
)

export default component.exports